<template>
  <div id="centre-container">
    <Title title="Centres"></Title>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{ snackbarText }}</v-snackbar>
    <v-container>
      <v-row>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterCentres('registered')">
            <InsightCard :title="'Registered'" :count="totalRegistered" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterCentres('active')">
            <InsightCard :title="'Active'" :count="totalActive" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterCentres('inactive')">
            <InsightCard :title="'Inactive'" :count="totalInactive" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterCentres('pending')">
            <InsightCard :title="'Pending'" :count="totalPending" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterCentres('closed')">
            <InsightCard :title="'Closed'" :count="totalClosed" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterCentres('active(awaiting payment)')">
            <InsightCard :title="'Awaiting Payment'" :count="totalAwaitingPayment" />
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12">
          <CentreTable
            :headers="centreHeaders"
            :items="modifiedCentres"
            :title="'centre.centre'"
            :modalText="'Centre'"
            :apiRoute="'centres'"
            :isLoading="isCentresLoading"
            @optionAdded="onOptionAdded"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CentreTable from "../components/CentreTable";
import InsightCard from "../components/InsightCard";
import Title from "../components/Title";

export default {
  components: {
    CentreTable,
    InsightCard,
    Title,
  },
  mounted: function () {
    this.getCentres();

    // display snackbar after add or edit centre
    if (this.$route.params.message) {
      this.snackbarText = this.$route.params.message;
      this.snackbar = true;
    }
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      centres: [],
      modifiedCentres: [],
      isCentresLoading: true,
    };
  },
  computed: {
    centreHeaders: function () {
      return [
        {
          text: this.$t("centre.code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        { text: this.$t("centre.name"), value: "name" },
        { text: "Country", value: "country" },
        { text: "Status", value: "status" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    totalRegistered: function () {
      return this.centres.length;
    },
    totalPending: function () {
      const totalPending = this.centres.filter((centre) => {
        if (centre.status) {
          return centre.status.toLowerCase() == "pending";
        }
      });

      return totalPending.length;
    },
    totalActive: function () {
      const totalActive = this.centres.filter((centre) => {
        if (centre.status) {
          return centre.status.toLowerCase() == "active";
        }
      });

      return totalActive.length;
    },
    totalInactive: function () {
      const totalInactive = this.centres.filter((centre) => {
        if (centre.status) {
          return centre.status.toLowerCase() == "inactive";
        }
      });

      return totalInactive.length;
    },
    totalClosed: function () {
      const totalClosed = this.centres.filter((centre) => {
        if (centre.status) {
          return centre.status.toLowerCase() == "closed";
        }
      }); 

      return totalClosed.length;
    },
    totalAwaitingPayment: function () {
      const totalAwaitingPayment = this.centres.filter((centre) => {
        if (centre.status) {
          return centre.status.toLowerCase() == "active(awaiting payment)";
        }
      });

      return totalAwaitingPayment.length;
    },
  },
  watch: {
    isCentresLoading: function (newValue) {
      this.isCentresLoading = newValue;
    },
  },
  methods: {
    getCentres: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/centres`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.centres = data.centres;
          this.modifiedCentres = data.centres;
          this.isCentresLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onOptionAdded: function (data) {
      this.getCentres();

      this.snackbarText = data.message;
      this.snackbar = true;
    },
    onFilterCentres: function (type) {
      if (type == "registered") {
        this.modifiedCentres = this.centres;
        return;
      }

      this.modifiedCentres = this.centres.filter((centre) => {
        if (centre.status) {
          return centre.status.toLowerCase() == type;
        }
      });
    },
  },
};
</script>

<style scoped>
h3 {
  display: inline-block;
}

#centre-container {
  min-height: 100vh;
}
</style>